<template>
  <!-- 我的订单页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar
        title="我的商城"
        @click-left="toIndex"
        left-text
        left-arrow
      />
    </div>
    <div class="center">
      <!-- 我的订单 -->
      <div class="orderSelect">
        <div
          class="top"
          @click="$router.push({ path: '/myOrder2', query: { type: '1' } })"
        >
          <p><span>我的订单</span><span class="quan">查看全部</span></p>
        </div>
        <div class="orderList">
          <ul>
            <li
              @click="$router.push({ path: '/myOrder2', query: { type: '2' } })"
            >
              <van-badge :content="ToBePaid.length == 0 ? '' : ToBePaid.length">
                <img src="../../assets/img/orderIcon/组 9681@2x.png" alt="" />
              </van-badge>
              <p>待付款</p>
            </li>
            <li
              @click="$router.push({ path: '/myOrder2', query: { type: '3' } })"
            >
              <van-badge
                :content="ToBeDelivered.length == 0 ? '' : ToBeDelivered.length"
              >
                <img src="../../assets/img/orderIcon/组 9682@2x.png" alt="" />
              </van-badge>
              <p>待发货</p>
            </li>
            <li
              @click="$router.push({ path: '/myOrder2', query: { type: '4' } })"
            >
              <van-badge
                :content="ToBeReceived.length == 0 ? '' : ToBeReceived.length"
              >
                <img src="../../assets/img/orderIcon/组 9683@2x.png" alt="" />
              </van-badge>
              <p>待收货</p>
            </li>
            <li @click="$router.push({ path: '/evaluationCenter' })">
              <van-badge
                :content="
                  ToBeEvaluateds.length == 0 ? '' : ToBeEvaluateds.length
                "
              >
                <img src="../../assets/img/orderIcon/组 9680@2x.png" alt="" />
              </van-badge>
              <p>待评价</p>
            </li>
            <li @click="$router.push({ path: '/refund' })">
              <van-badge
                :content="AfterSales.length == 0 ? '' : AfterSales.length"
              >
                <img src="../../assets/img/orderIcon/组 9679@2x.png" alt="" />
              </van-badge>
              <p>退款/售后</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 列表 -->
      <div class="serviceSelect">
        <ul>
          <li @click="$router.push({ path: '/buyCart' })">
            <div>
              <img src="../../assets/img/orderIcon/组 9667@2x.png" alt="" />
              <p>我的购物车</p>
            </div>
            <span
              ><img src="../../assets/img/orderIcon/组 9660.png" alt=""
            /></span>
          </li>
          <li>
            <div>
              <img src="../../assets/img/orderIcon/组 9668@2x.png" alt="" />
              <p>我的优惠券</p>
            </div>
            <span>
              <img src="../../assets/img/orderIcon/组 9660.png" alt="" />
            </span>
          </li>
          <li @click="$router.push({ path: '/address' })">
            <div>
              <img src="../../assets/img/orderIcon/组 9677@2x.png" alt="" />
              <p>收货地址</p>
            </div>
            <span>
              <img src="../../assets/img/orderIcon/组 9660.png" alt="" />
            </span>
          </li>
          <li>
            <div>
              <img src="../../assets/img/orderIcon/组 9670@2x.png" alt="" />
              <p>关于宇起商城</p>
            </div>
            <span>
              <img src="../../assets/img/orderIcon/组 9660.png" alt="" />
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      headerImg: "",
      userName: "",
      ToBePaid: "",
      ToBeDelivered: "",
      ToBeReceived: "",
      ToBeEvaluated: "",
      ToBeEvaluateds: "",
      AfterSales: "",
    };
  },
  created() {
    this.getMyOrder();
  },
  methods: {
    toIndex() {
      this.$router.push("/index");
    },
    getMyOrder() {
      let type = location.search;
      this.$post({
        url: "/oor/findOmsOrderRecordInfo",
        method: "post",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
          pageSize: 10000,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            res.data.code.map((item) => {
              switch (item.order_status) {
                case 0:
                  return (item.order_status = "待付款");
                case 1:
                  return (item.order_status = "待发货");
                case 3:
                  return (item.order_status = "待收货");
                case 5:
                  return (item.order_status = "已完成");
                case 7:
                  return (item.order_status = "已取消");
                case 8:
                  return (item.order_status = "售后中");
                case 9:
                  return (item.order_status = "售后完成");
                case 10:
                  return (item.order_status = "退款中");
                case 11:
                  return (item.order_status = "退款完成");
                default:
                  break;
              }
            });
            this.orderList = res.data.code.filter((item) => {
              return item.order_status !== -1;
            });

            this.ToBePaid = res.data.code.filter((item) => {
              return item.order_status == "待付款" || item.order_status == "0";
            });
            this.ToBeDelivered = res.data.code.filter((item) => {
              return item.order_status == "待发货" || item.order_status == "1";
            });
            this.ToBeReceived = res.data.code.filter((item) => {
              return item.order_status == "待收货" || item.order_status == "3";
            });
            this.ToBeEvaluated = res.data.code.map((item) => {
              return item.detailList;
            });
            this.ToBeEvaluated = [].concat(...this.ToBeEvaluated);

            this.ToBeEvaluateds = this.ToBeEvaluated.filter((item) => {
              return (
                (item.order_status == "5" ||item.order_status == "8"||item.order_status == "9" )&&
                item.comment_status == 0
              );
            });
            this.AfterSales = res.data.code.filter((item) => {
              return (
                item.saleService.length != 0 &&
                item.saleService[0].status != 3 &&
                item.saleService[0].status != 7 &&
                item.saleService[0].status !== 8 &&
                item.saleService[0].status !== 9 &&
                item.saleService[0].status !== 12
              );
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  background: #e8e8e8;
  overflow: hidden;
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: #ffffff;
    .van-nav-bar {
      background-color: transparent !important;
      .van-nav-bar__title.van-ellipsis {
        font-size: 0.48rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          color: #333333 !important;
          font-size: 0.533333rem;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 600 !important;
      }
    }
    .van-hairline--bottom::after {
      border-bottom-width: 0;
    }
  }
  .center {
    padding: 0 0.373333rem;
    .orderSelect {
      background-color: #ffffff;
      margin-top: 1.6rem;
      width: 9.253333rem;
      border-radius: 0.133333rem;
      .top {
        height: 1.6rem;
        line-height: 1.6rem;
        margin: 0 0.4rem;
        border-bottom: 0.026667rem solid #eeeeee;

        p {
          display: flex;
          justify-content: space-between;
        }
        .quan {
          // display: block;
          // display: block;
          // margin-left: 5rem;
          font-size: 0.373333rem;
          color: #999999;
        }
      }
      .orderList {
        ul {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 0.4rem;
          li {
            text-align: center;
            padding: 0.4rem 0;
            img {
              width: 0.746667rem;
              height: 0.746667rem;
            }
            p {
              font-size: 0.373333rem;
              color: #333333;
            }
          }
        }
      }
    }
    .serviceSelect {
      width: 9.253333rem;
      margin-top: 0.186667rem;
      border-radius: 0.133333rem;
      background-color: #ffffff;
      ul {
        li {
          height: 1.6rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0 0.4rem;
          border-bottom: 0.026667rem solid #eeeeee;
          div {
            display: flex;
            p {
              margin-left: 0.346667rem;
              font-size: 0.4rem;
              font-weight: 400;
              color: #333333;
            }
            img {
              width: 0.533333rem;
              height: 0.533333rem;
            }
          }
        }
      }
    }
  }
}
</style>
